import React, { useState } from 'react';
import styled from 'styled-components';
import 'react-phone-number-input/style.css';
import PhoneInput from 'react-phone-number-input';
import { supabase } from '../lib/supabase';
import { sendToUon } from '../lib/uon';
const Container = styled.section`
  background-color: #ededed;
  padding: 40px 0;
  position: relative;
  overflow: hidden;
  z-index: 1;
  clear: both;
`;

const Content = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  gap: 30px;
  flex-wrap: wrap;
  position: relative;
  
  @media (max-width: 960px) {
    flex-direction: column;
  }
`;

const MapContainer = styled.div`
  flex: 1;
  min-width: 660px;
  height: 635px;
  position: relative;
  border-radius: 7px;
  overflow: hidden;
  
  iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
  
  @media (max-width: 960px) {
  min-width: 300px;

    height: 400px;
    width: 100%;
    order: 2;
    margin-top: 20px;
  }
`;

const MapOverlay = styled.div`
  position: absolute;
  top: 10px;
  left: 362px;
  width: 290px;
  padding: 20px;
  background-color: white;
  border-radius: 7px;
  box-shadow: 0 5px 15px rgba(0,0,0,0.1);
  z-index: 10;
  
  @media (max-width: 1200px) {
    left: 30px;
    top: 30px;
  }
  
  @media (max-width: 960px) {
    position: relative;
    top: 0;
    left: 0;
    width: 100%;
    margin-top: 25px;
    z-index: 20;
  }
`;

const InfoLabel = styled.div`
  color: #000;
  opacity: 0.4;
  font-size: 14px;
  margin-bottom: 5px;
`;

const InfoValue = styled.div`
  color: #383838;
  font-size: 16px;
  margin-bottom: 15px;
  line-height: 1.4;
`;

const PhoneValue = styled.div`
  font-size: 20px;
  font-weight: 600;
  
  a {
    color: #383838;
    text-decoration: none;
    display: block;
    margin-bottom: 5px;
    
    &:hover {
      color: #3c57d2;
    }
  }
  
  @media (max-width: 479px) {
    font-size: 16px;
  }
`;

const FormContainer = styled.div`
  flex: 1;
  min-width: 300px;
  background-color: white;
  border-radius: 7px;
  padding: 30px;
  box-shadow: 0px 0px 50px 0px rgba(0, 0, 0, 0.1);
  position: relative;
  z-index: 5;
  
  @media (max-width: 960px) {
    order: 1;
  }
  
  @media (max-width: 479px) {
    padding: 20px;
  }
`;

const FormTitle = styled.h3`
  color: #383838;
  font-size: 24px;
  font-weight: 600;
  text-align: center;
  margin-bottom: 20px;
  
  @media (max-width: 479px) {
    font-size: 22px;
  }
`;

const FormSubtitle = styled.p`
  color: #383838;
  font-size: 18px;
  text-align: center;
  margin-bottom: 30px;
`;

const ButtonGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-bottom: 30px;
`;

const Button = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 55px;
  border: 1px solid ${({ color }) => color || '#33abe0'};
  border-radius: 7px;
  background-color: white;
  color: ${({ color }) => color || '#33abe0'};
  font-size: 16px;
  font-weight: 600;
  text-decoration: none;
  transition: all 0.2s;
  
  &:hover {
    background-color: ${({ color }) => color || '#33abe0'};
    color: white;
  }
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 20px;
`;

const PhoneInputWrapper = styled.div`
  position: relative;
  width: 100%;
  
  .PhoneInput {
    display: flex;
    align-items: center;
    position: relative;
    width: 100%;
  }
  
  .PhoneInputCountry {
    position: absolute;
    left: 15px;
    top: 50%;
    transform: translateY(-50%);
    z-index: 2;
    margin-right: 0;
    display: flex;
    align-items: center;
    gap: 5px;
    background: transparent;
    pointer-events: none;
  }
  
  .PhoneInputCountryIcon {
    width: 24px;
    height: 18px;
  }
  
  .PhoneInputCountrySelect {
    position: absolute;
    top: 0;
    left: 0;
    height: 100%;
    width: 60px;
    opacity: 0;
    cursor: pointer;
    z-index: 3;
    pointer-events: auto;
  }
  
  .PhoneInputInput {
    width: 100%;
    height: 88px;
    padding: 0 20px 0 70px;
    border: 1px solid #f0f0f0;
    border-radius: 10px;
    background-color: #fafafa;
    font-size: 16px;
    font-family: 'Geologica', Arial, sans-serif;
    position: relative;
    z-index: 1;
    
    &:focus {
      outline: none;
      border-color: #33abe0;
    }
  }
`;

const SubmitButton = styled.button`
  width: 100%;
  height: 100px;
  background: linear-gradient(0deg, #FF6163 0%, #FF9050 100%);
  border: none;
  border-radius: 10px;
  color: white;
  font-size: 16px;
  font-weight: 600;
  font-family: 'Geologica', Arial, sans-serif;
  cursor: pointer;
  transition: opacity 0.2s;
  
  &:hover {
    opacity: 0.9;
  }
`;

const CheckboxLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
  color: #949494;
  
  input[type="checkbox"] {
    width: 16px;
    height: 16px;
    cursor: pointer;
  }
  
  a {
    color: #5dd04b;
    text-decoration: none;
    
    &:hover {
      text-decoration: underline;
    }
  }
`;





const ContactForm = () => {
  const [phone, setPhone] = useState('');
  const [name, setName] = useState('');
  const [agreed, setAgreed] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitSuccess, setSubmitSuccess] = useState(false);
  const [submitError, setSubmitError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmitError('');

    try {
      // Save to Supabase (admin panel)
      const { error: supabaseError } = await supabase
        .from('applications')
        .insert([
          {
            name,
            phone,
            page_url: window.location.pathname,
            status: 'new'
          }
        ]);

      // Handle 409 Conflict error (duplicate entry)
      if (supabaseError) {
        if (supabaseError.code === '23505' || supabaseError.status === 409) {
          // If it's a duplicate, try to update existing record instead
          const { error: updateError } = await supabase
            .from('applications')
            .update({
              name,
              page_url: window.location.pathname,
              status: 'new',
              updated_at: new Date().toISOString()
            })
            .eq('phone', phone);
          
          if (updateError) {
            console.error('Update error:', updateError);
            throw updateError;
          }
        } else {
          throw supabaseError;
        }
      }

      // Send to u-on.travel
      await sendToUon({
        name,
        phone,
        page_url: window.location.pathname
      });

      setSubmitSuccess(true);
      setName('');
      setPhone('');
      setAgreed(false);
      
      setTimeout(() => {
        setSubmitSuccess(false);
      }, 3000);
    } catch (err) {
      console.error('Error submitting application:', err);
      setSubmitError('Произошла ошибка. Пожалуйста, попробуйте позже.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <Container>
      <Content>
        <FormContainer>
          <FormTitle>Есть вопросы? Задайте нам любой интересующий</FormTitle>
          <FormSubtitle>Напишите нам в удобный для вас мессенджер</FormSubtitle>
          
          <ButtonGroup>
            <Button href="https://wa.me/79146579607" color="#6ebf3a" target="_blank">
              Написать в WhatsApp
            </Button>
            <Button href="https://t.me/+79964269652" color="#33abe0" target="_blank">
              Написать в Telegram
            </Button>
            <Button href="https://max.ru/u/f9LHodD0cOL05pXnV7sGho8C51851PbX_ovWLzTbmK_WySWcq1eOWjiqIUo" color="#8F00FF" target="_blank">
              Написать в Max
            </Button>
          </ButtonGroup>
          
          <FormSubtitle>Или оставьте заявку на звонок</FormSubtitle>
          
          <Form onSubmit={handleSubmit}>
            <PhoneInputWrapper>
              <PhoneInput
                placeholder="+7 (___) ___ - __ - __"
                value={phone}
                onChange={setPhone}
                defaultCountry="RU"
                international
                countryCallingCodeEditable={false}
                required
                disabled={isSubmitting || submitSuccess}
              />
            </PhoneInputWrapper>
            
            <SubmitButton type="submit" disabled={isSubmitting || submitSuccess}>
              {isSubmitting ? 'Отправка...' : submitSuccess ? 'Отправлено!' : 'ПОЛУЧИТЬ КОНСУЛЬТАЦИЮ'}
            </SubmitButton>
            
            {submitError && (
              <div style={{ color: '#dc2626', textAlign: 'center', fontSize: '14px' }}>
                {submitError}
              </div>
            )}
            
            <CheckboxLabel>
              <input
                type="checkbox"
                checked={agreed}
                onChange={(e) => setAgreed(e.target.checked)}
                required
              />
              Я принимаю <a href="#popup:politica">условия передачи информации</a>
            </CheckboxLabel>
          </Form>
        </FormContainer>
        
        <MapContainer>
          <iframe
            src="https://yandex.ru/map-widget/v1/?um=constructor%3Af39e5eebaf4c35490249c8d7226304f55c7d785a81e4a27b74c4abd8380f9fb0&amp;source=constructor"
            title="map"
          />
          <MapOverlay>
            <div>
              <InfoLabel>Адрес:</InfoLabel>
              <InfoValue>Владивосток, Алеутская улица, 45а​, 40 офис, 1 этаж</InfoValue>
            </div>
            <div>
              <InfoLabel>Телефон:</InfoLabel>
              <PhoneValue>
                <a href="tel:+79964269652">+7 (996) 426‒96‒52</a>
                <a href="tel:+79245200072">+7 (924) 520‒00‒72</a>
                <a href="tel:+79146579607">+7 (914) 657‒96‒07</a>

              </PhoneValue>
            </div>
          </MapOverlay>
        </MapContainer>
      </Content>
    </Container>
  );
};

export default ContactForm;